import {
  SHOW_MODAL_QUERY_PARAM,
  CONDUCTOR_FUNCTIONAL_MODAL,
} from "@faire/deprecated-retailer-visitor-shared/components/App/AppModals/consts";
import { SlateButton } from "@faire/deprecated-retailer-visitor-shared/components/SlateElements/Button/SlateButton";
import { SlateText } from "@faire/deprecated-retailer-visitor-shared/components/SlateElements/Text/SlateText";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { CONDUCTOR_MODAL_CONTENT_IDENTIFIER_QUERY_PARAM_KEY } from "@faire/sdui/lib/consts";
import { trackProductMessagingInProductMessageBannerClick } from "@faire/web-api--source/events/productMessaging/click/inProductMessageBanner";
import { trackProductMessagingInProductMessageBannerHover } from "@faire/web-api--source/events/productMessaging/hover/inProductMessageBanner";
import { IProductMessage } from "@faire/web-api--source/indigofair/retailer/IProductMessage";
import { Flex } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { useCurrentPath } from "@faire/web/ui/hooks/useCurrentPath";
import React from "react";
import { useHistory } from "react-router-dom";

// at least 400 ms to count as an intentional hover
const MIN_HOVER_TIME = 400;

interface IProps {
  message: IProductMessage;
}

export const ImpBanner: React.FC<IProps> = ({ message }) => {
  const history = useHistory();
  const currentPath = useCurrentPath();
  const [onMouseEnterTime, setOnMouseEnterTime] = React.useState<
    number | undefined
  >();

  const {
    text_segments,
    background_color,
    cta_and_action,
    campaign_name = "",
  } = message;

  const onClickHandler = () => {
    trackProductMessagingInProductMessageBannerClick(campaign_name);

    if (cta_and_action?.action?.open_modal_action?.campaign_name) {
      onClickOpenModal();
    }
  };

  const onClickOpenModal = () => {
    history.replace(
      currentPath
        .append({
          [SHOW_MODAL_QUERY_PARAM]: CONDUCTOR_FUNCTIONAL_MODAL,
          [CONDUCTOR_MODAL_CONTENT_IDENTIFIER_QUERY_PARAM_KEY]:
            cta_and_action?.action?.open_modal_action?.campaign_name,
        })
        .toString()
    );
  };

  const onMouseEnter = () => {
    setOnMouseEnterTime(Date.now());
  };

  const onMouseLeave = () => {
    if (!onMouseEnterTime) {
      return;
    }

    const timeSpent = Date.now() - onMouseEnterTime;

    if (timeSpent > MIN_HOVER_TIME) {
      trackProductMessagingInProductMessageBannerHover(campaign_name);
    }

    setOnMouseEnterTime(undefined);
  };

  return (
    <Flex
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      align="center"
      style={{
        width: "100%",
        height: "100%",
        padding: getSpacing("1x", "3x"),
        background: getSlateColorToken(background_color),
      }}
      data-test-id={campaign_name ? `${campaign_name}_BANNER` : undefined}
    >
      <div
        style={{
          margin: "0 auto",
          width: "fit-content",
          textAlign: "center",
        }}
      >
        {text_segments.map((text_segment) => (
          <span key={text_segment.text}>
            <SlateText textElement={text_segment} />{" "}
          </span>
        ))}
        <SlateButton
          variant="tertiary"
          textElement={cta_and_action?.cta_text}
          linkTo={cta_and_action?.action?.open_link_action?.link_url}
          onClick={onClickHandler}
        />
      </div>
    </Flex>
  );
};
